<template>
    <!--添加/编辑连锁店-->
    <div v-if="editShow">
        <PopForm width="610px" body-max-height="760px">
            <template v-slot:title>添加门店</template>
            <el-form class="form-box" ref="editData" :model="editData" :rules="editRules" label-width="100px">
                <el-form-item label="门店名称" prop="store_name">
                    <el-input v-model="editData.store_name" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="地址" prop="region" class="is-required">
                    <el-select v-model="editData.province" placeholder="省" class="region-width" @change="provinceClick(editData.province)">
                        <el-option
                                v-for="item in region.province"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-select v-model="editData.city" placeholder="市" class="region-width" @change="cityClick(editData.city)">
                        <el-option
                                v-for="item in region.city"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>&nbsp;
                    <el-select v-model="editData.area" placeholder="区" class="region-width">
                        <el-option
                                v-for="item in region.area"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址" prop="address">
                    <el-input v-model="editData.address" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="店长姓名" prop="manager_name">
                    <el-input v-model="editData.manager_name" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="手机" prop="mobile">
                    <el-input v-model="editData.mobile" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="用户名" prop="username">
                    <el-input v-model="editData.username" placeholder="请输入登录账号，6 ~ 18个字符，字母或数字" />
                </el-form-item>
                <el-form-item label="密码" prop="password" :class="{'is-required': !id}">
                    <el-input v-model="editData.password" :placeholder="!id ? '请输入登录密码' : '要设置的新密码，不修改请留空'" show-password />
                </el-form-item>
                <el-form-item label="确认密码" prop="password_again" class="no-padding" :class="{'is-required': !id}">
                    <el-input v-model="editData.password_again" placeholder="请再次输入登录密码" show-password />
                </el-form-item>
            </el-form>
            <template v-slot:foot>
                <div class="pop-foot">
                    <el-button size="medium" @click="cancelSave">&nbsp;&nbsp;关闭&nbsp;&nbsp;</el-button>
                    <el-button size="medium" type="primary" @click="submitSave">&nbsp;&nbsp;确定&nbsp;&nbsp;</el-button>
                </div>
            </template>
        </PopForm>
    </div>
</template>

<script>
    import PopForm from "@/model/PopForm";
    import obj from "@/js/obj";
    export default {
        name: "ChainEditChildStore",
        components: {PopForm},
        model: {
            prop: "editShow",
            event: "stateChange"
        },
        props: {
            editShow: {
                type: Boolean,
                default: false
            },
            id: {
                type: [Number, String],
                default: ""
            }
        },
        data(){
            let checkRegion = (rule, value, callback) => {
                if(obj.isEmpty(this.editData.province) || obj.isEmpty(this.editData.city) || obj.isEmpty(this.editData.area))
                    callback(new Error("请选择您所在地址"));
                else
                    callback();
            };
            let checkPassword = (rule, value, callback) => {
                if(this.editData.password !== this.editData.password_again)
                    callback(new Error("两次密码输入不一致"));
                else if(!this.editData.password && !this.id)
                    callback(new Error("请输入登录密码"));
                else
                    callback();
            };

            return {
                editData: {
                    province: "",
                    city: "",
                    area: "",
                },
                editRules: {
                    store_name: [
                        { required: true, message: '请输入门店名称', trigger: 'blur' },
                    ],
                    region: [
                        { validator: checkRegion, trigger: 'blur'}
                    ],
                    address: [
                        { required: true, message: '请填写详细地址', trigger: 'blur' },
                    ],
                    manager_name: [
                        { required: true, message: '请填写店长姓名', trigger: 'blur' }
                    ],
                    mobile: [
                        { required: true, message: '请填写手机号码', trigger: 'blur' },
                        { pattern:/^1[0-9]{10}$/, message: '请输入正确的手机号码', trigger: 'blur' }
                    ],
                    username: [
                        { required: true, message: '请输入登录用户名', trigger: 'blur' },
                    ],
                    password: [
                        { validator: checkPassword, trigger: 'blur'}
                    ],
                },

                region: {
                    province: [],
                    city: [],
                    area: []
                },
            };
        },
        methods: {
            init() {
                this.loadProvince();
                if(!this.id) {
                    //添加
                    this.editData = {
                        province: "",
                        city: "",
                        area: "",
                    };
                }else{
                    //编辑
                    this.loadChildStoreInfo();
                }
            },

            //点击省
            provinceClick(){
                this.editData.city = "";
                this.editData.area = "";
            },

            //点击市
            cityClick(){
                this.editData.area = "";
            },

            //加载省数据
            loadProvince() {
                obj.postData("public/get_region_list", {}, res => {
                    if(res.errcode === 0) {
                        this.region = {
                            province: res.data,
                            city: [],
                            area: []
                        };
                    }
                });
            },

            //加载市数据
            loadCity() {
                let fid = this.editData.province;
                if(!fid) return false;
                obj.postData("public/get_region_list", {fid: fid}, res => {
                    if(res.errcode === 0) {
                        this.region.city = res.data;
                    }
                });
            },

            //加载区数据
            loadArea() {
                let fid = this.editData.city;
                if(!fid) return false;
                obj.postData("public/get_region_list", {fid: fid}, res => {
                    if(res.errcode === 0) {
                        this.region.area = res.data;
                    }
                });
            },

            //加载门店信息
            loadChildStoreInfo () {
                this.$root.postData("chain/get_child_store_info", {id: this.id}, res => {
                    if(res.errcode === 0){
                        this.editData = res.data;
                        this.loadCity();
                        this.loadArea();
                    }else{
                        this.$root.error(res.errdesc);
                    }
                });
            },

            //确定提交
            submitSave () {
                this.$refs["editData"].validate( valid => {
                    if(!valid) return false;

                    let postData = {
                        store_name: this.editData.store_name,
                        province: this.editData.province,
                        city: this.editData.city,
                        area: this.editData.area,
                        address: this.editData.address,
                        mobile: this.editData.mobile,
                        manager_name: this.editData.manager_name,
                        username: this.editData.username,
                    };
                    if(!this.id) {
                        postData.password = this.editData.password;
                        this.$root.postData("chain/add_child_store", postData, res => {
                            if(res.errcode === 0){
                                obj.message.success("门店添加成功");
                                this.$emit("stateChange", false);
                                this.$emit("reload");
                            }else{
                                obj.message.error(res.errdesc);
                            }
                        });
                    }else{
                        postData.id = this.id;
                        if(this.editData.password) postData.password = this.editData.password;
                        this.$root.postData("chain/set_child_store", postData, res => {
                            if(res.errcode === 0){
                                this.$root.success("门店设置成功");
                                this.$emit("stateChange", false);
                                this.$emit("reload");
                            }else{
                                this.$root.error(res.errdesc);
                            }
                        });
                    }
                });
            }

            //取消
            ,cancelSave () {
                this.$emit("stateChange", false);
            }
        },
        watch: {
            editShow(val){
                if(val) this.init();
            },
            "editData.province"(){
                this.loadCity();
            },
            "editData.city"(){
                this.loadArea();
            }
        }
    }
</script>

<style scoped>
    .region-width{
        width: 139px;
        height: 40px;
    }
    .form-box{
        padding-right: 40px;
        height: 495px;
    }
    .pop-foot{
        padding-right: 50px;
        padding-bottom: 10px;
        text-align: right;
    }
    .no-padding{
        margin-bottom: 10px;
    }
</style>
